import { render, staticRenderFns } from "./lkuKoranKota.vue?vue&type=template&id=53791b42"
import script from "./lkuKoranKota.vue?vue&type=script&lang=js"
export * from "./lkuKoranKota.vue?vue&type=script&lang=js"
import style0 from "./lkuKoranKota.vue?vue&type=style&index=0&id=53791b42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports